import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { SignUpPageStyled } from '../SignUpPage.styled'

export const FormLayout = styled(SignUpPageStyled)({
  backgroundColor: colors.white,
  color: colors.black,
  fontFamily: font.family.primary,

  '> footer': {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
})

export const DocumentBodyStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
})
